/**
 * @file ProductHeaderActions.tsx
 * @description Видимые кнопки шапки карточки товара (phase19.31, SC67 —
 * действия не прячутся в «⋯»): «Отменить изменения» (если есть правки),
 * «Опубликовать» / «Снять с публикации», последней — опасная «В архив» (с
 * подтверждением). Главное действие «Сохранить» — отдельно, в `action`
 * заголовка (на телефоне — в общей нижней полосе).
 *
 * Название товара важнее кнопок (приёмка QA-5 D13: «Райски…» на 1280). Две
 * части (`part`) для `CabinetPageHeader`:
 *  - `panel` — «Отменить изменения» и «Опубликовать» (`panelActions`): в
 *    панели только от 1280 (с «Сохранить» — не больше трёх), уже — строкой
 *    под шапкой;
 *  - `row` — «В архив» (`secondaryActions` + `secondaryBelow`): всегда
 *    строкой под шапкой.
 */

import { Archive, Eye, EyeOff, Undo2 } from "lucide-react";

import { Button } from "../../../../components/ui/button";
import type { CatalogProduct } from "../../../../lib/api-catalog";

interface Props {
  part: "panel" | "row";
  product: CatalogProduct;
  dirty: boolean;
  saving: boolean;
  onDiscard: () => void;
  onTogglePublish: () => void;
  onArchive: () => void;
}

export function ProductHeaderActions({ part, product, dirty, saving, onDiscard, onTogglePublish, onArchive }: Props) {
  const archived = product.status === "ARCHIVED";
  const published = product.status === "ACTIVE";
  if (part === "row") {
    return archived ? null : (
      <Button variant="destructive" onClick={onArchive} disabled={saving}>
        <Archive className="size-4" aria-hidden />
        В архив
      </Button>
    );
  }
  return (
    <>
      {dirty ? (
        <Button variant="outline" onClick={onDiscard} disabled={saving}>
          <Undo2 className="size-4" aria-hidden />
          Отменить изменения
        </Button>
      ) : null}
      {archived ? null : (
        <Button variant="outline" onClick={onTogglePublish} disabled={saving}>
          {published ? <EyeOff className="size-4" aria-hidden /> : <Eye className="size-4" aria-hidden />}
          {published ? "Снять с публикации" : "Опубликовать"}
        </Button>
      )}
    </>
  );
}
